import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setStockorderproductSorting} from 'store/slice/ManufSlice';

export default function StockorderproductListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.stockorderproductDashboard);
  const {mobileView} = useSelector((state) => state.menu);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setStockorderproductSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        {/* <Grid item lg={2} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}> Title </Typography></Grid> */}
                        <Grid item lg={3} md={3} sm={3} xs={8} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productname')}> Product</Typography></Grid>
                        <Grid item lg={1} md={1} sm={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('qty')}> Qty </Typography></Grid>
                        {!mobileView?<>
                        <Grid item lg={2} md={2} sm={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('matter')}> Matter </Typography></Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('deliverypriorityname')}> Priority </Typography></Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('expecteddelivery')}> Expected By </Typography></Grid>
                        </>
                        :<></>}
                        
      </Grid>
      
    )
}